/*******************************************************************************
GET CLOUDINARY TO IGNORE HIDDEN IMAGES
Activate the images on the page that are being loaded through Cloudinary.
*******************************************************************************/

export default function hideHiddenImagesFromCloudinary() {
    // This prevents hidden images from being processed by Cloudinary
    $('.cld-responsive').filter(':hidden').removeClass('cld-responsive').addClass('cld-responsive-hidden');
}
